import { render } from "./distributorwisedealerstock_form.vue?vue&type=template&id=d3fb87b8&scoped=true"
import script from "./distributorwisedealerstock_form.vue?vue&type=script&lang=js"
export * from "./distributorwisedealerstock_form.vue?vue&type=script&lang=js"

import "./distributorwisedealerstock_form.vue?vue&type=style&index=0&id=d3fb87b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3fb87b8"]])

export default __exports__